import { render, staticRenderFns } from "./ContentForm.vue?vue&type=template&id=3e536a54&scoped=true"
import script from "./ContentForm.vue?vue&type=script&lang=js"
export * from "./ContentForm.vue?vue&type=script&lang=js"
import style0 from "./ContentForm.vue?vue&type=style&index=0&id=3e536a54&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e536a54",
  null
  
)

export default component.exports